import request from '@/utils/request';

// 获取所有变现渠道分类及渠道
export const getMonetizeChannels = () => {
  return request.get('/monetize');
};

// 获取单个变现渠道详情
export const getMonetizeChannelDetail = (id) => {
  return request.get(`/monetize/${id}`);
};

// === 以下是管理员接口 ===

// 获取所有变现渠道分类
export const getMonetizeCategories = () => {
  return request.get('/monetize/admin/categories');
};

// 创建变现渠道分类
export const createMonetizeCategory = (data) => {
  return request.post('/monetize/admin/categories', data);
};

// 更新变现渠道分类
export const updateMonetizeCategory = (id, data) => {
  return request.put(`/monetize/admin/categories/${id}`, data);
};

// 删除变现渠道分类
export const deleteMonetizeCategory = (id) => {
  return request.delete(`/monetize/admin/categories/${id}`);
};

// 获取所有变现渠道
export const getAllMonetizeChannels = () => {
  return request.get('/monetize/admin/channels');
};

// 创建变现渠道
export const createMonetizeChannel = (formData) => {
  return request.post('/monetize/admin/channels', formData);
};

// 更新变现渠道
export const updateMonetizeChannel = (id, formData) => {
  return request.put(`/monetize/admin/channels/${id}`, formData);
};

// 删除变现渠道
export const deleteMonetizeChannel = (id) => {
  return request.delete(`/monetize/admin/channels/${id}`);
}; 